// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import NativeInput from "@werner/App/Components/XngExpirationDatePicker/Inputs/NativeInput";
import { baseClassName } from "@werner/App/Components/XngExpirationDatePicker/utils/constants";
import {
    formatValue,
    getInputWidth,
    validateMonth,
} from "@werner/App/Components/XngExpirationDatePicker/utils/helpers";
import { CommonInputProps } from "@werner/App/Components/XngExpirationDatePicker/utils/types";
import React from "react";

interface OwnProps {
    onChange?: (month: string) => void;
}

type MonthInputProps = Omit<CommonInputProps, "onChange"> & OwnProps & InjectableCss;

const MonthInput: React.FC<MonthInputProps> = ({ onChange, value, className, inputRef, ariaLabel, ...otherProps }) => {
    const handleChange: React.ChangeEventHandler<HTMLInputElement> = event => {
        const validatedValue = validateMonth(event.target.value, value || "");
        onChange?.(validatedValue);
    };

    const formattedValue = formatValue(value);
    const inputWidth = getInputWidth(formattedValue);
    return (
        <NativeInput
            {...otherProps}
            onChange={handleChange}
            value={formattedValue}
            className={`${baseClassName}__inputGroup__month ${className || ""}`}
            ref={inputRef}
            ariaLabel={ariaLabel}
            width={inputWidth}
        />
    );
};

MonthInput.defaultProps = {
    placeholder: "mm",
};

export default MonthInput;
